import React, { useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import GoalsPageListComponent from '../GoalsPageList/GoalsPageList.container';
import GoalsPageFilterComponent from '../GoalsPageFilter/GoalsPageFilter.container';
import query from '../../../../helpers/query';
import config from '../../../../config';

const images = {
    filter: require('img/offers/filter.svg'),
    filterMobile: require('img/offers/filter-mobile.svg'),
};

export function GoalsPageContainer(props) {
    const { onUpdate, t, searchString: pSearch, accessGranted: pAccess, offerLocales: pLocales } = props;
    const location = useLocation();

    const parsedQuery = useMemo(() => query.parse(location?.search || ''), [location?.search]);

    const [page, setPage] = useState((parsedQuery.page && +parsedQuery.page) || config.initialPage);
    const [modalIsVisible, setModalIsVisible] = useState(false);
    const [searchString, setSearchString] = useState(parsedQuery.searchString || pSearch);
    const [accessGranted] = useState(parsedQuery.accessGranted || pAccess);
    const [offerLocales] = useState(parsedQuery.offerLocales || pLocales);
    const [statuses] = useState([{ value: 'active' }]);

    const buildState = useCallback(
        (patch = {}) => ({
            page,
            modalIsVisible,
            searchString,
            accessGranted,
            offerLocales,
            statuses,
            ...patch,
        }),
        [page, modalIsVisible, searchString, accessGranted, offerLocales, statuses]
    );

    const onAction = useCallback(
        (patch) => {
            const next = buildState(patch);
            if (Object.prototype.hasOwnProperty.call(patch, 'page')) setPage(patch.page);
            if (Object.prototype.hasOwnProperty.call(patch, 'modalIsVisible')) setModalIsVisible(patch.modalIsVisible);
            if (Object.prototype.hasOwnProperty.call(patch, 'searchString')) setSearchString(patch.searchString);
            onUpdate(next);
            query.replace(next);
        },
        [buildState, onUpdate]
    );

    const handleSearchChange = useCallback(
        (e) => {
            const v = e.target.value;
            setSearchString(v);
            onAction({ searchString: v });
        },
        [onAction]
    );

    const openFilterModal = useCallback(() => setModalIsVisible(true), []);
    const onClose = useCallback(() => setModalIsVisible(false), []);

    const staticNames = (t && t.offersPage && t.offersPage.goalsList) || {
        byGoalName: 'By goal name',
        goalName: 'Goal name',
        minSymbols: 'Min 3 symbols',
    };

    return (
        <div className="ibox-content">
            <div className="filter-container">
                <div className="search">
                    <label htmlFor="goals-search-input" className="input-label bold">
                        {staticNames.byGoalName} <i className="fa fa-search"></i>
                    </label>
                    <input
                        id="goals-search-input"
                        name="goals-search"
                        className="form-control"
                        type="text"
                        placeholder={staticNames.goalName}
                        pattern=".{3,}"
                        title={staticNames.minSymbols}
                        onChange={handleSearchChange}
                    />
                </div>
                <GoalsPageFilterComponent
                    onAction={onAction}
                    modalIsVisible={modalIsVisible}
                    searchString={searchString}
                    onClose={onClose}
                />
                <div className="order-filer" onClick={openFilterModal}>
                    <img className="wrap__desktop" src={images.filter} alt="order filter" />
                    <img className="wrap__mobile" src={images.filterMobile} alt="order filter" />
                </div>
            </div>
            <GoalsPageListComponent onAction={onAction} page={page} />
        </div>
    );
}

GoalsPageContainer.propTypes = {
    onUpdate: PropTypes.func.isRequired,
    t: PropTypes.object,
    searchString: PropTypes.string,
    accessGranted: PropTypes.any,
    offerLocales: PropTypes.any,
};
